export var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType["OPEN"] = "OPEN";
    AvailabilityType["CLOSED"] = "CLOSED";
})(AvailabilityType || (AvailabilityType = {}));
